/*
    Enum representing the types of UI card, in order to support both grid and list layouts
 */
export enum CardType {
  Grid = 'grid',
  Row = 'row',
}
